export default "__VITE_ASSET__bcb47b31__"